import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ChevronDown, CircleHelp } from 'lucide-react';

import { useApp } from '@/presentation/hooks/use-app.js';

export function AiCritiqueSettingsHelp() {
    const { translate } = useApp();

    return (
        <Accordion
            disableGutters
            elevation={0}
            sx={{
                border: 1,
                borderColor: 'divider',
                borderRadius: '8px !important',
                overflow: 'hidden',
                bgcolor: 'background.paper',
                '&:before': { display: 'none' },
                boxShadow: 'none'
            }}
        >
            <AccordionSummary
                expandIcon={<ChevronDown size={16} strokeWidth={2} />}
                sx={{
                    minHeight: 44,
                    px: 1.5,
                    '& .MuiAccordionSummary-content': { my: 1 }
                }}
            >
                <Stack direction="row" spacing={1} alignItems="center">
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 24,
                            height: 24,
                            borderRadius: '50%',
                            bgcolor: 'action.hover',
                            color: 'text.primary',
                            flexShrink: 0
                        }}
                    >
                        <CircleHelp size={14} />
                    </Box>
                    <Typography variant="body2" fontWeight={500} color="text.primary">
                        {translate('aiCritique.helpToggleLabel')}
                    </Typography>
                </Stack>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 1.5, pt: 0, pb: 1.5 }}>
                <Stack spacing={1.5} divider={<Divider flexItem sx={{ borderColor: 'divider' }} />}>
                    <Box>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" display="block" sx={{ mb: 0.5, letterSpacing: 0.3 }}>
                            {translate('aiCritique.strictnessLabel')}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {translate('aiCritique.strictnessSummary')}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" display="block" sx={{ mb: 0.5, letterSpacing: 0.3 }}>
                            {translate('aiCritique.minScoreLabel')}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {translate('aiCritique.minScoreSummary')}
                        </Typography>
                    </Box>
                    <Typography variant="caption" color="text.secondary" display="block" sx={{ fontStyle: 'italic' }}>
                        {translate('aiCritique.example')}
                    </Typography>
                </Stack>
            </AccordionDetails>
        </Accordion>
    );
}
